import {
  DialogWindow,
  DialogHeader,
  DialogAdornment,
  ContentTransition,
  useDialog,
  color,
} from '@ticketswap/solar'
import { useTranslation } from '~/components/TranslationContext'
import Feedback from './Feedback'
import PositiveConfirm from './PositiveConfirm'
import NegativeConfirm from './NegativeConfirm'
import { CloseAlt } from '@ticketswap/solar/icons'
import { useState } from 'react'
import styled from '@emotion/styled'

const CloseDialogButton = styled.button`
  color: ${color.foreground};
`

const FeedbackDialog = ({ children }) => {
  const { t } = useTranslation()
  const [title, setTitle] = useState('')
  const [activeView, setActiveView] = useState('feedback')
  const { hide, getToggleProps, getWindowProps } = useDialog()

  return (
    <>
      {children({ getToggleProps, setActiveView, hide })}
      <DialogWindow {...getWindowProps()}>
        <DialogHeader>
          {title}
          <DialogAdornment right>
            <CloseDialogButton onClick={hide}>
              <CloseAlt size={24} />
            </CloseDialogButton>
          </DialogAdornment>
        </DialogHeader>
        <ContentTransition
          onChange={item => {
            setTitle(item.props.title)
          }}
          activeView={activeView}
        >
          <Feedback
            key="feedback"
            t={t}
            title={t('common:feedbackDialog.title')}
            setActiveView={setActiveView}
          />
          <PositiveConfirm
            key="positive-confirm"
            t={t}
            hide={hide}
            title={t('common:feedbackDialog.confirm.title')}
          />
          <NegativeConfirm
            key="negative-confirm"
            t={t}
            hide={hide}
            title={t('common:feedbackDialog.confirm.title')}
          />
        </ContentTransition>
      </DialogWindow>
    </>
  )
}

export default FeedbackDialog
